import { createLabeledMessages } from '../../../messageUtils';
const delegationsLight = {
    cancel: 'Zrušiť',
    setDelegation: 'Nastaviť zastúpenie',
    delegation: 'Zastúpenie'
};
export default Object.assign({}, delegationsLight, createLabeledMessages(delegationsLight));
